/** @format */

module.exports = {
  publicKey: "1a5ead8e448e6acbc1fe684a5475da25",
  hostnameId: "highroller",
};



// WEBPACK FOOTER //
// ./src/partners/config/partner.js